import { createElement, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Avatar, Tag, Icon, Timeline } from '@alifd/next';
import './index.scss';
import { matchFileType, previewAttach } from "../../utils/utils";
import { flowRecord } from "../../api/api";
const TimelineItem = Timeline.Item;
const typeDict = {
    0: { text: '提交申请', color: 'blue', icon: 'success', iconColor: 'green' },
    1: { text: '审批', color: 'green', icon: 'success' },
    2: { text: '驳回', color: 'red', icon: 'error' },
    3: { text: '驳回', color: 'red', icon: 'error' },
    6: { text: '取消申请', color: 'turquoise', icon: 'semi-select' },
    7: { text: '委派/转办', color: 'blue', icon: 'switch' },
    8: { text: '委派/转办', color: 'blue', icon: 'switch' },
    9: { text: '撤回', color: 'yellow', icon: 'refresh' },
    comment: { text: '评论', color: 'green', icon: 'switch' }
};
const FlowRecord = function FlowRecord(props, ref) {
    const [flowRecordList, setFlowRecordList] = useState([]);
    useImperativeHandle(ref, () => ({
        loadData,
    }));
    useEffect(() => {
        loadData();
    }, [props.procInsId]);
    const loadData = async () => {
        if (!props.procInsId)
            return;
        const { success, result } = await flowRecord({ params: { procInsId: props.procInsId } });
        if (!success)
            return;
        const { flowList, flowFurther } = result;
        const { taskAttributes, taskDefKey } = flowList[0];
        const flowFurtherCurrNodeIndex = flowFurther.map((item) => item.taskDefKey).indexOf(taskDefKey);
        const flowFurtherNodeList = flowFurther.map((item) => ({
            ...item,
            furtherNode: true
        })).filter((item, index) => index > flowFurtherCurrNodeIndex);
        let reverseFlowList = flowList.reverse();
        setFlowRecordList([...reverseFlowList, ...flowFurtherNodeList]);
    };
    const attachList = (item) => {
        const { attach = [], signattach = [] } = item;
        if (!attach && !signattach) {
            return false;
        }
        const nodeList = [...attach.split(","), signattach].filter((item) => item).map((item, index) => {
            const fileNames = item.split("_");
            const fileType = matchFileType(item);
            const name = fileNames[fileNames.length - 1];
            const url = item;
            let node = createElement("img", { key: index, src: url });
            if (fileType !== 'img') {
                node = (createElement("div", null,
                    createElement("a", { href: "#", key: index, onClick: () => previewAttach(fileType, url) }, name)));
            }
            return node;
        });
        return nodeList;
    };
    const user = (item) => {
        return (createElement("div", { className: "title" },
            createElement(Avatar, { shape: "square", src: item.startUserAvatar, size: "small", icon: "account" }),
            createElement("span", { className: "text" }, item.startUserName),
            typeTag(item.comment),
            createElement("span", { className: "time" }, item.finishTime)));
    };
    const typeTag = (comment) => {
        let typeTagObj = { text: '等待审核', color: 'orange', icon: 'clock' };
        if (comment) {
            typeTagObj = typeDict[comment.type];
        }
        console.log(comment);
        return createElement(Tag, { size: "small", color: typeTagObj.color }, typeTagObj.text);
    };
    const dot = (comment) => {
        let typeTagObj = { text: '等待审核', color: 'orange', icon: 'clock' };
        if (comment) {
            typeTagObj = JSON.parse(JSON.stringify(typeDict[comment.type]));
            if (typeTagObj.iconColor) {
                typeTagObj.color = typeTagObj.iconColor;
            }
        }
        return createElement(Icon, { type: typeTagObj.icon, size: "small", style: { color: typeTagObj.color } });
    };
    const content = (item) => {
        const { comment, attach, signattach } = item;
        let content = '';
        if (comment) {
            content = comment.comment;
        }
        if (!comment && !attach?.length && !signattach?.length) {
            return false;
        }
        return (createElement("div", { className: "content" },
            createElement("p", null,
                content,
                " "),
            attachList(item)));
    };
    const recordItem = flowRecordList.map(item => {
        return (createElement(TimelineItem, { title: user(item), dot: dot(item.comment), content: content(item), state: "process" }));
    });
    return (createElement("div", { className: "flow-record", ref: ref },
        createElement(Timeline, null, recordItem)));
};
const RefFlowRecord = forwardRef(FlowRecord);
export default RefFlowRecord;
